import * as e from "react";
import c from "../lib/IconBase.es.js";
import s from "../defs/PauseCircle.es.js";
const o = e.forwardRef((r, a) => /* @__PURE__ */ e.createElement(c, { ref: a, ...r, weights: s }));
o.displayName = "PauseCircleIcon";
const m = o;
export {
  m as PauseCircle,
  o as PauseCircleIcon
};
